import React from 'react'

import { graphql, useStaticQuery } from 'gatsby'

import WordpressMenu from '@components/Wordpress/WordpressMenu'

import { WpMenuType } from '@contracts/Components/Wordpress'

import * as styles from './Menu.module.scss'

const Menu = () => {
	const [menuOpen, setMenuOpen] = React.useState(false)
	const [menuStyles, setMenuStyles] = React.useState([styles.menu])
	const [menuToggleStyles, setMenuToggleStyles] = React.useState([styles.hamburger])

	const toggleMenu = () => {
		setMenuOpen(!menuOpen)

		if (!menuOpen) {
			setMenuToggleStyles([styles.hamburger, styles.active])
			setMenuStyles([styles.menu, styles.active])
		} else {
			setMenuToggleStyles([styles.hamburger])
			setMenuStyles([styles.menu])
		}
	}

	const data = useStaticQuery(graphql`
		query HeaderMenu {
			wpMenu(locations: { eq: HEADER_MENU }) {
				menuItems {
					nodes {
						label
						title
						path
						parentId
						id
						children {
							id
						}
					}
				}
			}
		}
	`)

	const menuData: WpMenuType = data.wpMenu.menuItems

	return (
		<nav className={menuStyles.join(' ')}>
			<div className={styles.menuToggle} onClick={toggleMenu}>
				<div className={menuToggleStyles.join(' ')}></div>
			</div>

			<WordpressMenu data={menuData} className={styles.navigation} />
		</nav>
	)
}

export default Menu
